<template>
    <div class="tr text-center header rounded-tl-md rounded-tr-md">
        <div class="td" v-for="header in headers" :key="`${header.text}_${header.value}`" :style="{'width': header.width}">
            <span> {{ header.text }} </span>
            <i aria-hidden="true" class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light" style="font-size: 18px;"></i>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({}),
    props: ['headers', 'item']
}
</script>

<style scoped>
    .tr {
        background-color: white;
        display: flex;
        word-break: normal;
        tab-size: 4;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        overflow-wrap: break-word;
        white-space: normal;
        font-size: .875rem;
        font-weight: 400;
        letter-spacing: .0071428571em;
        line-height: 1.5;
        color: rgba(0,0,0,.87);
        border-spacing: 0;
        background-repeat: no-repeat;
        box-sizing: inherit;
        padding: 0;
        margin: 0;
        font-family: Cairo,sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 50px;
    }
    .td {
        tab-size: 4;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        direction: rtl;
        overflow-wrap: break-word;
        white-space: normal;
        font-weight: 400;
        letter-spacing: .0071428571em;
        line-height: 1.2;
        color: rgba(0,0,0,.87);
        border-spacing: 0;
        background-repeat: no-repeat;
        box-sizing: inherit;
        margin: 0 !important;
        font-family: Cairo,sans-serif;
        text-align: center!important;
        padding: 0 4px !important;
        transition: height .2s cubic-bezier(.4,0,.6,1);
        font-size: .875rem;
        height: 50px;
        border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }
    div {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
</style>